import React from "react";

interface EyeIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

const EyeIcon: React.FC<EyeIconProps> = ({ width = 16, className, height = 16, color = "#595A61" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M14.23 6.95431C14.3958 7.16103 14.4876 7.4296 14.4876 7.70807C14.4876 7.98653 14.3958 8.2551 14.23 8.46183C13.18 9.73309 10.79 12.2081 8 12.2081C5.21 12.2081 2.82 9.73309 1.77 8.46183C1.60416 8.2551 1.51236 7.98653 1.51236 7.70807C1.51236 7.4296 1.60416 7.16103 1.77 6.95431C2.82 5.68304 5.21 3.20801 8 3.20801C10.79 3.20801 13.18 5.68304 14.23 6.95431Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 9.70801C9.10457 9.70801 10 8.81258 10 7.70801C10 6.60344 9.10457 5.70801 8 5.70801C6.89543 5.70801 6 6.60344 6 7.70801C6 8.81258 6.89543 9.70801 8 9.70801Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EyeIcon;
